import api from "../middlware/api";
import { camelToSnake } from "../utils/CamelToSnake";
import { BASE_URL } from "../constants";

// Save/Create patient transaction
export const savePatientTransaction = (params: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/patient-transactions`, camelToSnake(params))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Get patient transaction by ID
export const getPatientTransaction = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/patient-transactions/${id}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Update patient transaction
export const updatePatientTransaction = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .put(
        `${BASE_URL}/api/v1/patient-transactions/${payload.id}`,
        camelToSnake(payload)
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Get all patient transactions (with optional params for filtering)
// export const getPatientTransactions = (params: any = {}) => {
//   return new Promise((resolve, reject) => {
//     let query = new URLSearchParams();
//     if (params) {
//       for (let key in params) {
//         if (
//           params[key] !== undefined &&
//           params[key] !== null &&
//           params[key] !== ""
//         ) {
//           query.set(key, params[key]);
//         }
//       }
//     }
//     const queryString = query.toString();
//     let url: string;

//     url = `${BASE_URL}/api/v1/patient-transactions/patients/${params.patientId}?${queryString}`;

//     api
//       .get(url)
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

export const getPatientTransactions = (params: any = {}) => {
  const snakeParams = camelToSnake(params);
  let query = new URLSearchParams();
  for (let key in snakeParams) {
    if (snakeParams[key] !== undefined && snakeParams[key] !== null && snakeParams[key] !== "") {
      query.set(key, snakeParams[key]);
    }
  }

  let url = `${BASE_URL}/api/v1/patient-transactions`;
  if (snakeParams.patient_id) {
    url = `${BASE_URL}/api/v1/patient-transactions/patient/${snakeParams.patient_id}?${query.toString()}`;
  } else if (query.toString()) {
    url += `?${query.toString()}`;
  }

  return api.get(url)
    .then(res => res)
    .catch(err => { throw err });
};
